(ns frontend.view.grid.tenant-kyc-grid.columns
  (:require
   [frontend.state.current-session :as session]))

;;default set of selected columns
(def ordered-default-columns
  [:tenant-kyc-profile/name
   :tenant-kyc-profile/status
   :kyc-profile/risk-category
   :tenant-kyc-profile/next-deadline
   :tenant-kyc-profile/latest-process-status
   :tenant-kyc-profile/their-kyc-contact
   :tenant-kyc-profile/our-kyc-contact])

(def default-columns
  (set ordered-default-columns))

(defn get-ordered-default-columns
  []
  (vec
   (concat [:tenant-kyc-profile/name
            :tenant-kyc-profile/status]
           (when (session/screening?)
             [:tenant-kyc-profile/screening-status])
           [:kyc-profile/risk-category
            :tenant-kyc-profile/next-deadline
            :tenant-kyc-profile/latest-process-status
            :tenant-kyc-profile/their-kyc-contact
            :tenant-kyc-profile/our-kyc-contact])))

(defn get-default-columns
  []
  (set
   (concat [:tenant-kyc-profile/name
            :tenant-kyc-profile/status]
           (when (session/screening?)
             [:tenant-kyc-profile/screening-status])
           [:kyc-profile/risk-category
            :tenant-kyc-profile/next-deadline
            :tenant-kyc-profile/latest-process-status
            :tenant-kyc-profile/their-kyc-contact
            :tenant-kyc-profile/our-kyc-contact])))

;;always selected:
(def mandatory?
  #{:tenant-kyc-profile/name})
